import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Loader from '../LoaderV2';

import {
  Wrapper,
  Select,
  Text,
  Icon,
  Envelop,
  EnvelopItem,
  TextInput,
  TextInputWrapper,
  EnvelopWrapper,
  EmptyStateText,
  extendLoaderStyle,
} from './DropdownFilter.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const DropdownFilter = ({
  dropdownMenuItemsList,
  dropdownMenuPlaceholder,
  showLoader,
  handleDropdownMenuChange,
  emptyStateText,
}) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dropdownMenuWrapperRef = useRef(null);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isMenuEnvelopOpen, setIsMenuEnvelopOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filteredDropdownMenuItemsList, setFilteredDropdownMenuItemsList] = useState([
    ...dropdownMenuItemsList,
  ]);
  const [selectedItem, setSelectedItem] = useState();
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        dropdownMenuWrapperRef.current &&
        dropdownMenuWrapperRef.current.contains(event.target) === false
      )
        setIsMenuEnvelopOpen(false);
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [dropdownMenuWrapperRef]);

  useEffect(() => {
    if (dropdownMenuItemsList?.length > 0) {
      const filteredData = dropdownMenuItemsList.filter(({ name }) =>
        name.toLowerCase().includes(searchText.toLowerCase()),
      );
      setFilteredDropdownMenuItemsList([...filteredData]);
    }
  }, [dropdownMenuItemsList, searchText]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleMenuSelectClick = () => {
    setIsMenuEnvelopOpen(prevState => !prevState);
  };

  const handleDropdownMenuItemClick = selectedObj => {
    setIsMenuEnvelopOpen(false);
    handleDropdownMenuChange(selectedObj);
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <Wrapper ref={dropdownMenuWrapperRef}>
      <Select
        data-testid="dropdown-menu-select"
        onClick={handleMenuSelectClick}
        isSelected={selectedItem}
      >
        <Text data-testid="dropdown-menu-text">
          {selectedItem?.name || dropdownMenuPlaceholder}
        </Text>
        {showLoader && <Loader extendStyle={extendLoaderStyle} />}
        {selectedItem && (
          <Icon
            icon={'"\\e91f"'}
            onClick={() => {
              setSelectedItem();
              handleDropdownMenuItemClick('');
            }}
          />
        )}
      </Select>
      {isMenuEnvelopOpen && (
        <EnvelopWrapper data-testid="dropdown-menu-envelope">
          <TextInputWrapper>
            <Icon icon={'"\\e905"'} margin="10px" />
            <TextInput
              data-testid="dropdown-menu-text"
              type="text"
              value={searchText}
              placeholder={`Search ${dropdownMenuPlaceholder}`}
              onChange={event => setSearchText(event.target.value)}
            />
            {searchText && (
              <Icon
                icon={'"\\e91f"'}
                margin="10px"
                onClick={() => {
                  setSearchText('');
                  setFilteredDropdownMenuItemsList([...dropdownMenuItemsList]);
                }}
              />
            )}
          </TextInputWrapper>
          <Envelop>
            {filteredDropdownMenuItemsList.map(menuItem => (
              <EnvelopItem
                data-testid={menuItem.key}
                key={menuItem.key}
                onClick={() => {
                  setSelectedItem(menuItem);
                  handleDropdownMenuItemClick(menuItem?.key);
                }}
              >
                {menuItem.name}
              </EnvelopItem>
            ))}
            {filteredDropdownMenuItemsList.length === 0 && (
              <EmptyStateText>{emptyStateText}</EmptyStateText>
            )}
          </Envelop>
        </EnvelopWrapper>
      )}
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

DropdownFilter.propTypes = {
  dropdownMenuItemsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dropdownMenuPlaceholder: PropTypes.string,
  showLoader: PropTypes.bool,
  handleDropdownMenuChange: PropTypes.func.isRequired,
};

DropdownFilter.defaultProps = {
  dropdownMenuPlaceholder: '',
  showLoader: false,
};

export default DropdownFilter;
